import { render, staticRenderFns } from "./RegisterFields.vue?vue&type=template&id=819f2b52&scoped=true"
import script from "./RegisterFields.vue?vue&type=script&lang=js"
export * from "./RegisterFields.vue?vue&type=script&lang=js"
import style0 from "./RegisterFields.vue?vue&type=style&index=0&id=819f2b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819f2b52",
  null
  
)

export default component.exports